import React from 'react';
import style from './style/CompetencyTag.module.scss';

const CompetencyTag = ({ label, classes = { root: '' } }) => (
    <div className={`${style.tagWrapper} ${classes.root}`}>{label}</div>
);

export default CompetencyTag;
